import { Statuses } from '../constants/statuses';
import { createBaseApi, getAuthHeaders } from '../utils/baseApi';

const apiVersion = 'v1';

const { getJson, postJson, deleteJson, putJson } = createBaseApi(`/api/${apiVersion}`, { headers: getAuthHeaders });

export const getCompanyById = companyId => getJson(`/companies/${companyId}`);

export const getCompanyUsers = companyId => getJson(`/companies/${companyId}/users`);

export const getCompanyPolicyTypes = (companyId, filter) => getJson(`/companies/${companyId}/policy-types`, { filter });

export const getCompanyDocumentTypes = (companyId, filter) => getJson(`/companies/${companyId}/document-types`, { filter });

export const getCompanyItemTypes = (id, include) => getJson(`/companies/${id}/item-types`, include);

export const getCompanyCodes = id => getJson(`companies/${id}/codes`);

export const createCompanyCustomRole = (companyId, name, permissions, description) => postJson(`companies/${companyId}/roles`, { name, permissions, description });

export const getCompanyCustomRoles = (companyId, includes) => getJson(`companies/${companyId}/roles`, includes);

export const getCompanyPermissions = companyId => getJson(`companies/${companyId}/permissions`);

export const deleteCompanyRole = (companyId, roleId) => deleteJson(`companies/${companyId}/roles/${roleId}`);

export const updateCompanyRole = (companyId, roleId, name, permissions, description) => putJson(`companies/${companyId}/roles/${roleId}`, { name, permissions, description });

export const listRequirementTemplateFolders = (companyId, pageData) => getJson(`/companies/${companyId}/requirement-template-folders`, pageData);

export const listCompanyInsureds = (companyId, pageData, filter, sort, include) => getJson(`/companies/${companyId}/insureds`, pageData, { filter }, { sort }, { include });

export const listCompanyQuestions = (companyId, pageData, filter) => getJson(`/companies/${companyId}/question-categories`, pageData, { filter });

export const requestFeatureType = (companyId, featureTypeId) => postJson(`/companies/${companyId}/feature-types/${featureTypeId}`);

export const createCompanyQuestionCategory = (companyId, name) => postJson(`/companies/${companyId}/question-categories`, { name });

export const createCompanyQuestion = (companyId, categoryId, name, question, redFlag) => postJson(`/companies/${companyId}/question-categories/${categoryId}/questions`, { name, question, red_flag: redFlag });

export const updateCompany = (companyId, data) => putJson(`/companies/${companyId}`, data);

export const createContract = (companyId, fileName) => postJson(`/companies/${companyId}/contracts`, {
  file_name: fileName,
  status: Statuses.Created
});

export const updateContract = (companyId, contractId, updateData) => putJson(`/companies/${companyId}/contracts/${contractId}`, updateData);

export const deleteContract = (companyId, contractId) => deleteJson(`/companies/${companyId}/contracts/${contractId}`);
